import { Button, Icon } from "antd";
import React, { useEffect, useState } from "react";

const PaginationKaBaap = (props) => {
    const [pagination, setPagination] = useState({
        pageSize: 15,
        current: 1,
        hasNext: true,
        showing: { from: 1, to: 15 }

    });

    const getNextPage = () => {
        let _pagination = { ...pagination, current: pagination.current + 1 };
        setPagination(_pagination);
        props.pageChange(_pagination);
    }

    const getPrevPage = () => {
        let _pagination = { ...pagination, current: pagination.current - 1 };
        setPagination(_pagination);
        props.pageChange(_pagination);
    }

    const goToFirst = () => {
        let _pagination = { ...pagination, current: 1 };
        setPagination(_pagination);
        props.pageChange(_pagination);
    }

    useEffect(() => {
        setPagination({ ...props.pagination })
    }, [props.pagination])

    return (
        <div>
            <div className="d-flex justify-content-center align-items-center mt-4">
                <Button icon="vertical-right" className="mr-1" disabled={pagination.current == 1} onClick={goToFirst}>First</Button>
                <Button icon="left" disabled={pagination.current == 1} onClick={getPrevPage}>Prev</Button>
                <span style={{ minWidth: 30, textAlign: 'center' }} className="mx-2">{pagination.current < 10 ? '0' : ''}{pagination.current}</span>
                <Button disabled={!pagination.hasNext} onClick={getNextPage}>Next <Icon type="right" /></Button>
            </div>
            <div className="d-flex justify-content-center align-items-center mt-3">
                Showing {pagination?.showing?.from} to {pagination?.showing?.to}
            </div>
        </div>
    )
};

export { PaginationKaBaap };